const sectorOptions = [
  { text: 'California (North)', value: 'California (North)' },
  { text: 'California (South)', value: 'California (South)' },
];

export default sectorOptions;
